var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-middle"},[_c('h1',[_vm._v("404")]),_c('h4',[_vm._v("PAGE NOT FOUND")])])}]

export { render, staticRenderFns }